import React from 'react';
import {useSelector} from 'react-redux';
import Loader from '@e74/core/Loader';

export default () => {
  const loading = useSelector((state) => state.common.loading);
  return loading && <Loader />;
};
